export var SessionStorageKeys;
(function (SessionStorageKeys) {
    SessionStorageKeys["CrossCampaignEntry"] = "cross-campaign-entry";
    SessionStorageKeys["CrossCampaign"] = "cross-campaign";
    SessionStorageKeys["SearchCrossCampaign"] = "search-cross-campaign";
    SessionStorageKeys["Filters"] = "filters";
    SessionStorageKeys["Search"] = "search";
})(SessionStorageKeys || (SessionStorageKeys = {}));
export var CROSS_CAMPAIGN_KEY = 'category_id';
export var PRE_OPEN_CATEGORIES_FILTER_KEY = 'pre-open-categories-filter';
